import React from "react";
import { observer } from "mobx-react";
import styled from "styled-components";
import { SettingsForm } from "../components/Settings";
import { settingsController } from "../modules/controllers";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Settings = observer(() => {
  return (
    <Wrapper>
      <SettingsForm controller={settingsController} />
    </Wrapper>
  );
});
